import { AjaxMethods } from "@wlhy-web-lib/ajax";

export const defaultMethod = (next, config) => {
  if (!config.method) {
    config.method = AjaxMethods.POST;
  }

  return next();
};
